import { useSSAuth } from "./useSSAuth";
import { useRouterExt } from "./useRouterExt";
import { useOktaHelper } from "../context/OktaProvider";
import { useTeamConfig } from "../components/TeamConfigProvider";
import { useGlobalStore } from "./useGlobalStore";

export function useTicketsdotcom() {
  const router = useRouterExt();
  const { loginToSs } = useSSAuth();
  const { TEAM_SCHEMA } = useTeamConfig();
  const { handleGetOktaAuthClient } = useOktaHelper();
  const client = handleGetOktaAuthClient();
  const { mlbBallparkUser } = useGlobalStore();

  async function connectTicketsdotcom(state: any) {
    try {
      state = state || {};
      state.teamSchema = TEAM_SCHEMA;
      state = window.btoa(JSON.stringify(state));

      if (client) {
        window.localStorage.removeItem("okta-token-storage");
        window.localStorage.removeItem("okta-cache-storage");
        window.localStorage.removeItem("okta-original-uri-storage");
        window.localStorage.removeItem("okta-shared-transaction-storage");

        const isBallparkUser = Boolean(mlbBallparkUser?.mlbBallparkOktaId);
        if (isBallparkUser) {
          router.query.state = state;
          return await loginToSs();
        }

        const isAuthenticated = await client.isAuthenticated();
        if (!isAuthenticated) await client.signInWithRedirect({ state }); // prettier-ignore
        if (isAuthenticated) await loginToSs();
      }
    } catch (error: any) {
      console.log(error);
    }
  }

  async function handleSignOut(logoutRedirectRoute?: string) {
    try {
      const oktaClient = handleGetOktaAuthClient();

      window.localStorage.removeItem("okta-token-storage");
      window.localStorage.removeItem("okta-cache-storage");
      window.localStorage.removeItem("okta-original-uri-storage");
      window.localStorage.removeItem("okta-shared-transaction-storage");

      const state = window.btoa(JSON.stringify({ teamSchema: TEAM_SCHEMA, mlbcallback: true, logoutRedirectRoute })); // prettier-ignore
      await oktaClient.signOut({ state });
    } catch (error) {
      console.log(error);
    }
  }

  return { handleSignOut, connectTicketsdotcom };
}
